module.exports = __webpack_public_path__ + "static/media/champion01.716c6b14.jpg";